<script lang="ts">
  import type { Snippet } from "svelte"
  import ActionBox from "@kontextwerk/web-sdk/ui/layout/ActionBox.svelte"
  import StepActionCTA from "../step-action-cta"

  type Props = {
    label?: string
    tag?: string
    tagTooltipContent?: string
    darkMode?: boolean
    modeRed?: boolean
    selectedCount?: number
    targetCount?: number
    pending?: boolean
    disabled?: boolean
    emptyLabel?: string
    pendingLabel?: string
    children?: Snippet | null
    onApply: () => void | Promise<void>
  }

  let {
    label = "Vorkonfiguration",
    tag = "",
    tagTooltipContent = "",
    darkMode = false,
    modeRed = false,
    selectedCount = 0,
    targetCount = 0,
    pending = false,
    disabled = false,
    emptyLabel = "Keine passenden Zeilen",
    pendingLabel = "Wird angewendet...",
    children,
    onApply,
  }: Props = $props()

  const applyLabel = $derived(
    pending
      ? pendingLabel
      : selectedCount > 0
        ? `Auf ausgewählte anwenden (${targetCount})`
        : `Auf alle anwenden (${targetCount})`,
  )
  const effectiveDisabled = $derived(disabled || pending || targetCount <= 0)
  const disabledTooltip = $derived(targetCount <= 0 ? emptyLabel : "")
</script>

<ActionBox {label} {tag} {tagTooltipContent} {darkMode} {modeRed}>
  <div style="display: flex; flex-direction: column; gap: 1.2rem; padding-top: 1rem;">
    {@render children?.()}
  </div>
  {#snippet buttonSnippet()}
    <StepActionCTA
      type="tertiaryButton"
      content={applyLabel}
      darkMode={true}
      disabledReason={disabledTooltip}
      disabled={effectiveDisabled}
      onClick={() => void onApply()}
    />
  {/snippet}
</ActionBox>
